export const addParamsToUrl = (url: string, params: any): string => {
  const paramsKeys = Object.keys(params);

  const filteredFalsyParamsKeys = paramsKeys.filter((key) => {
    if (Array.isArray(params[key]) && !params[key]?.length) {
      return false;
    }

    if (params[key] === 0) {
      return true;
    }

    return Boolean(params[key]);
  });

  if (filteredFalsyParamsKeys.length === 0) {
    return url;
  }

  const paramsString = filteredFalsyParamsKeys.reduce((acc, key, index) => {
    const value = params[key];

    if (index === filteredFalsyParamsKeys.length - 1) {
      return `${acc}${key}=${value}`;
    }

    return `${acc}${key}=${value}&`;
  }, "");

  return `${url}?${paramsString}`;
};
